// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { processBadgeDiscount } from 'src/scripts/templates/product-listing-page/PlpUtils/ProcessBadgeDiscount';
import { toLocalCurrency } from '../../../../utils/currency';
import { RecommendationServiceNode } from '../../../product/components/SimilarItems/RecommendationServiceCarousel/RecommendationServiceTypes';
import { getProductPrices } from 'src/scripts/templates/product/components/SimilarItems/helpers';

let PGWCarouselItem = ({ product, isMobile }: PGWCarouselItemTypes) => {
  if (!product) {
    return null;
  }
  const productPrice = Math.trunc(product.priceRange.maxVariantPrice.amount);
  const productCompareAtPrice = Math.trunc(product.compareAtPriceRange.maxVariantPrice.amount);
  const [price, compareAtPrice] = getProductPrices(product.tags, productPrice, productCompareAtPrice);

  const { title, handle, images } = product;
  const [imgSrc] = images;

  const isOnSale = compareAtPrice && compareAtPrice > price;

  const titleLength = isMobile ? 15 : 30;
  return (
    <div className="product-carousel--wrapper insta-product crosssell-product">
      <a href={`/products/${handle}`}>
        <img className="img-fluid product-carousel-image" src={imgSrc || ''} alt={title} />
      </a>
      {isOnSale && compareAtPrice ? (
        <span className="product-card-badge tag-small uppercase">{processBadgeDiscount(compareAtPrice, price)}</span>
      ) : null}
      <a href={`/products/${handle}`}>
        <p className="product-name product-carousel-title">
          {title.length > titleLength ? `${title.slice(0, titleLength)}...` : title}
        </p>
      </a>
      <span
        className={
          isOnSale
            ? 'product-price product-carousel-price product__price sale__price mr-2'
            : 'product-price product-carousel-price product__price'
        }
        data-currency
      >
        {toLocalCurrency(price)}
        {isOnSale && compareAtPrice ? (
          <span className="product__price--sale">
            <s>{toLocalCurrency(compareAtPrice)}</s>
          </span>
        ) : null}
      </span>
    </div>
  );
};
PGWCarouselItem = observer(PGWCarouselItem);

export default PGWCarouselItem;

type PGWCarouselItemTypes = {
  product: RecommendationServiceNode;
  isMobile: boolean;
};
